import { render } from "./SlackMessage.vue?vue&type=template&id=10eaef19"
import script from "./SlackMessage.vue?vue&type=script&lang=js"
export * from "./SlackMessage.vue?vue&type=script&lang=js"

import "./SlackMessage.vue?vue&type=style&index=0&id=10eaef19&lang=sass"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__